var map = {
	"./az.json": 9686,
	"./de.json": 5894,
	"./en.json": 4174,
	"./en_sc.json": 1793,
	"./es.json": 6725,
	"./fr.json": 4605,
	"./hi.json": 3134,
	"./hr.json": 6759,
	"./hy.json": 4638,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./kk.json": 7699,
	"./ko.json": 9423,
	"./mo.json": 7937,
	"./my.json": 7243,
	"./pl.json": 1029,
	"./pt.json": 7741,
	"./pt_br.json": 7186,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./th.json": 7549,
	"./tk.json": 2768,
	"./tr.json": 9755,
	"./uk.json": 2749,
	"./uz.json": 7906,
	"./zh.json": 9527,
	"./zh_cn.json": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4649;